
define('css!taoClientDiagnosticCss/diagnostics',[],function(){});
